import * as React from 'react';

interface IProps {
	color?: string;
}

const SendFiles2DIcon: React.FC<IProps> = ({ color = '#05386B' }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='16'
		height='16'
		fill='none'
		viewBox='0 0 16 16'>
		<g clipPath='url(#clip0_1366_2354)'>
			<g clipPath='url(#clip1_1366_2354)'>
				<path
					fill={color}
					d='M15.854.145a.5.5 0 0 1 .11.54l-5.82 14.547a.75.75 0 0 1-1.328.124l-3.178-4.995L.643 7.183a.75.75 0 0 1 .124-1.33L15.314.036a.5.5 0 0 1 .54.11M6.636 10.07l2.76 4.338L14.13 2.575zm6.787-8.2L1.59 6.6l4.339 2.76z'></path>
			</g>
		</g>
		<defs>
			<clipPath id='clip0_1366_2354'>
				<path
					fill='#fff'
					d='M0 0h16v16H0z'></path>
			</clipPath>
			<clipPath id='clip1_1366_2354'>
				<path
					fill='#fff'
					d='M0 0h16v16H0z'></path>
			</clipPath>
		</defs>
	</svg>
);

export default SendFiles2DIcon;
